module.exports = "/_next/static/images/et-f306ee809cd60094cad49ea9c103b199.svg";